// extracted by mini-css-extract-plugin
export default {"wrapper":"ActionCard_wrapper__qDF2-"};